import { createSelector } from '@ngrx/store';
import type { IAuthState } from './auth.reducer';

export const selectAuthState: (state: any) => IAuthState = state => state.auth;

export const isLoggedIn = createSelector(selectAuthState, auth => !!auth.currentUser);

export const isLoggedOut = createSelector(isLoggedIn, loggedIn => !loggedIn);

export const getToken = createSelector(selectAuthState, auth => auth.token || null);

export const getCurrentUser = createSelector(selectAuthState, auth => auth.currentUser);

export const getCurrentUserPsId = createSelector(
	selectAuthState,
	auth => auth.currentUser?.psId
);

export const getAuthTranslate = createSelector(
	selectAuthState,
	auth => auth.authTranslate
);

export const getRecoveryMessage = createSelector(
	selectAuthState,
	auth => auth.message?.password_reset
);

export const getEmailSentStatus = createSelector(
	selectAuthState,
	auth => auth.resetEmailSent
);

export const getAfterPasswordChangedData = createSelector(selectAuthState, auth => ({
	message: (auth.authTranslate?.password_changed as Record<string, string> | undefined)
		?.subtitle,
	isLoggedIn: !!auth.currentUser,
}));

export const getFollowedBuildings = createSelector(
	selectAuthState,
	auth => auth?.currentUser?.followingBuildings
);
